// Help-line data shape + pure helpers for Help now (Tool Plan §12, D-69; I-1a batch 5).
//
// The data itself comes only from content/help/package.yaml through
// tools/content/build_help.py (helpPackage.generated.ts). Nothing here holds a
// number. Links are plain: tel: / sms: start a call or a message only on the
// person's tap; a chat link opens the line's own page or WhatsApp.

export type HelpGroup = 'strip-danger' | 'strip-talk' | 'line'
export type ChatKind = 'web' | 'whatsapp'

export interface HelpItem {
  readonly id: string
  readonly group: HelpGroup
  /** Short name, used in the strip ("Call MDA 101"). */
  readonly label: string
  /** Card heading in the help lines; defaults to the label. */
  readonly title?: string
  /** Dial string as printed: digits, dashes, an optional leading star code. */
  readonly tel?: string
  readonly sms?: string
  /** Hours of the phone line, e.g. "24/7". */
  readonly hours?: string
  readonly chatUrl?: string
  readonly chatKind?: ChatKind
  readonly chatHours?: string
  readonly note?: string
  readonly verified: boolean
  readonly verifiedDate: string
}

export interface HelpPackage {
  readonly id: string
  readonly version: number
  readonly status: string
  readonly items: readonly HelpItem[]
}

/** `tel:` link for a printed dial string; dashes are only for reading. */
export function telHref(tel: string): string {
  return `tel:${tel.replace(/-/g, '')}`
}

export function smsHref(sms: string): string {
  return `sms:${sms.replace(/-/g, '')}`
}

export interface HelpLayout {
  /** "Danger or medical emergency" half of the strip. */
  readonly danger: readonly HelpItem[]
  /** "Need to talk now" half of the strip. */
  readonly talk: readonly HelpItem[]
  /** The help-line cards: the talk-now lines again (with all their channels), then the fixed lines. */
  readonly lines: readonly HelpItem[]
}

export function layoutHelp(items: readonly HelpItem[]): HelpLayout {
  const talk = items.filter((item) => item.group === 'strip-talk')
  return {
    danger: items.filter((item) => item.group === 'strip-danger'),
    talk,
    lines: [...talk, ...items.filter((item) => item.group === 'line')],
  }
}
